"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m11.82 22.06v-2.25a1 1 0 0 1 .26-.67 1 1 0 0 1 -.26-.67v-2.24a1 1 0 0 1 .26-.67 1 1 0 0 1 -.26-.68v-2.24a1 1 0 0 1 1-1h5.29a7 7 0 0 0 -3.14-3 3 3 0 0 0 -5.97.04 7 7 0 0 0 -4 6.32v4.5a1.53 1.53 0 0 1 -1.51 1.5.47.47 0 0 0 -.48.48.48.48 0 0 0 .48.48h6.08a2.47 2.47 0 0 0 4.37 1.06h-1.12a1 1 0 0 1 -1-.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12.82 12.31a.34.34 0 0 0 -.34.33v2.24a.34.34 0 0 0 .34.34h.78v-2.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.67 12.31h-9.73v2.91h9.73a.34.34 0 0 0 .33-.34v-2.24a.33.33 0 0 0 -.33-.33z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12.82 15.89a.34.34 0 0 0 -.34.34v2.24a.34.34 0 0 0 .34.33h.78v-2.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.67 18.8a.33.33 0 0 0 .33-.33v-2.24a.34.34 0 0 0 -.33-.34h-9.73v2.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.67 22.39a.33.33 0 0 0 .33-.33v-2.25a.33.33 0 0 0 -.33-.33h-9.73v2.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12.82 19.48a.34.34 0 0 0 -.34.33v2.25a.34.34 0 0 0 .34.33h.78v-2.91z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9 3a6 6 0 0 0 -6 6 .48.48 0 0 0 .48.48.49.49 0 0 0 .52-.48 5 5 0 0 1 5-5 .48.48 0 0 0 .48-.48.47.47 0 0 0 -.48-.52z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9 1a.47.47 0 0 0 .47-.52.47.47 0 0 0 -.47-.48 9 9 0 0 0 -9 9 .48.48 0 1 0 1 0 8 8 0 0 1 8-8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15 4a5 5 0 0 1 5 5 .48.48 0 0 0 .48.48.49.49 0 0 0 .52-.48 6 6 0 0 0 -6-6 .47.47 0 0 0 -.48.48.48.48 0 0 0 .48.52z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15 1a8 8 0 0 1 8 8 .48.48 0 1 0 1 0 9 9 0 0 0 -9-9 .47.47 0 0 0 -.48.48.47.47 0 0 0 .48.52z"
  })));
};

exports["default"] = _default;